export type OverlayGeometry = google.maps.Polygon

export interface DrawResult {
  type: google.maps.drawing.OverlayType
  overlay: OverlayGeometry
}

export interface Snapshot {
  path?: Array<google.maps.LatLng>
}

export interface Overlay {
  geometry: OverlayGeometry
  snapshot: Snapshot
}

export interface State {
  now: Array<Overlay>
}

export enum DrawingActionKind {
  SET_INITIAL_OVERLAYS = 'SET_INITIAL_OVERLAYS',
  SET_OVERLAY = 'SET_OVERLAY',
  UPDATE_OVERLAYS = 'UPDATE_OVERLAYS',
  REMOVE_OVERLAY = 'REMOVE_OVERLAY',
}

export interface ActionWithTypeOnly {
  type: Exclude<DrawingActionKind, DrawingActionKind.SET_OVERLAY>
}

export interface SetOverlayAction {
  type: DrawingActionKind.SET_OVERLAY
  payload: DrawResult
}

export interface RemoveOverlayAction {
  type: DrawingActionKind.REMOVE_OVERLAY
  payload: number
}

export interface InitialOverlayAction {
  type: DrawingActionKind.SET_INITIAL_OVERLAYS
  payload: [number, number][][]
}

export type Action =
  | ActionWithTypeOnly
  | SetOverlayAction
  | RemoveOverlayAction
  | InitialOverlayAction
